import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Button } from '@material-ui/core';

function getModalStyle() {
  return {
    top: `${50}%`,
    left: `${50}%`,
    transform: `translate(-${50}%, -${50}%)`,
    minHeight: "40%",
    width: "90%",
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: "100",
    height: "80%",
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  modalStyle1:{
    display:'block',
  }
}));

export default function TrainerModal({id, data}) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [trainer] = React.useState(data[id])

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button color="primary" onClick={handleOpen}>
      View Profile
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modalStyle1}
      >
        <div style={modalStyle} className={classes.paper}>
        <div className="">
          <div style={{display: "-ms-inline-flexbox"}}>
            <div style={{ marginLeft: "10px", display: "flex"}}>
              <div>
              <div style={{display: "flex"}}>
              <h4><b>Name:</b>&nbsp;
            <i style={{color: "blue"}}> {trainer.name}</i>
            </h4>
              </div>
              <div style={{display: "flex"}}>
              <h4><b>Skill:</b> &nbsp;
              <i style={{color: "blue"}}>{trainer.skill}</i>
              </h4>
              </div>
              <div style={{display: "flex"}}>
              <h4><b>Subject:</b> &nbsp;
              <i style={{color: "blue"}}>{trainer.subject}</i>
              </h4>
              </div>
              <div style={{display: "flex"}}>
              <h4><b>Qualification:</b>&nbsp;
              <i style={{color: "blue"}}>{trainer.qualification}</i>
              </h4>
              </div>
              <div style={{display: "flex"}}>
              <h4><b>Vision: </b>&nbsp;
              <i style={{color: "blue"}}>{trainer.vision}</i>
              </h4>
              </div>
              <div style={{display: "flex", flexDirection: "row"}}>
              <h4><b>Message to students: </b>&nbsp;
              <i style={{color: "blue"}}>{trainer.message}</i></h4>
              </div>
              <div style={{display: "flex"}}>
              <h4><b>Comment: </b>&nbsp;
              <i style={{color: "blue"}}>{trainer.comment}</i>
              </h4>
              </div>
              </div>
            <img src={trainer.image} width="250" loading="lazy" height="250" alt="" />
              </div>

          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
        <button style={{color: "blue"}} type="button" onClick={handleOpen}>
        Close
      </button>

          </div>
              </div>
              </div>
      </Modal>
    </div>
  );
}
